import styled from '@emotion/styled'
import { Modal, Button } from 'antd'
import { useMemo } from 'react'

import invalidDarkIcon from '@/assets/invalidDarkIcon.png'
import invalidLightIcon from '@/assets/invalidLightIcon.png'
import { useLocalStorage } from '@/context/localstorage-context'

const XWANWrapConfirmModal = ({
  visible,
  onCancel,
  onConfirm,
}: {
  visible: boolean
  onCancel: () => void
  onConfirm: () => void
}) => {
  const { theme } = useLocalStorage()
  const isdark = useMemo(() => theme === 'dark', [theme])

  return (
    <Modal
      maskClosable={true}
      closable={true}
      destroyOnClose={true}
      width={558}
      mask={true}
      open={visible}
      title={null}
      footer={null}
      onCancel={onCancel}
      centered
      className={`${isdark ? 'darkModal' : 'lightModal'} xwan-stake-modal`}
    >
      <Title className="dark:text-white">Reminder</Title>
      <StatusIcon
        src={isdark ? invalidDarkIcon : invalidLightIcon}
      ></StatusIcon>
      <StatusTxtCon className="text-light-0 dark:text-white">
        Wrapping is instant; unwrapping vests over{' '}
        <span className="text-light-111 dark:text-dark-111">0–90 days</span>.
        You won’t get all WAN back immediately upon unwrapping.
      </StatusTxtCon>
      <div className="grid md:grid-cols-1 grid-cols-2 gap-4">
        <ConfirmButton onClick={onConfirm} className="bg-light-111 text-white">
          I understand
        </ConfirmButton>
        <ConfirmButton
          onClick={onCancel}
          className="bg-light-1999 text-light-444 dark:bg-dark-1666 dark:text-dark-1222"
        >
          Cancel
        </ConfirmButton>
      </div>
    </Modal>
  )
}

export default XWANWrapConfirmModal

const Title = styled.div`
  font-family: Inter;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
`

const StatusIcon = styled.img`
  width: 16rem;
  height: 16rem;
  margin: 1.6rem auto;
  display: block !important;
`

const StatusTxtCon = styled.div`
  text-align: center;
  font-family: Inter;
  font-size: 1.6rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-bottom: 2.4rem;
`

const ConfirmButton = styled(Button)`
  padding: 2rem 0;
  height: fit-content;
  border-radius: 1.6rem;
  font-family: Inter;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  border: none;
`
